import * as React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import "./chat/chat-ui.scss";

export type ChatAssistantMarkdownProps = {
  text: string;
  /**
   * @deprecated Kept for SummaryPage callers that previously passed theme palette.
   * Styling now uses CSS tokens; this prop is ignored.
   */
  theme?: unknown;
  /** `chat`: 12px bubble typography; `panel`: slightly larger (e.g. agreement summary). */
  density?: "chat" | "panel";
};

/**
 * True when `raw` looks like an HTML fragment (e.g. `<p>…`) rather than Markdown/plain text.
 */
export function looksLikeHtmlProse(raw: string): boolean {
  const t = raw.trimStart();
  return t.length > 0 && t.startsWith("<") && /^<[a-z]/i.test(t);
}

/**
 * Renders assistant chat prose as Markdown (GFM): lists, emphasis, code fences, tables, links.
 */
export function ChatAssistantMarkdown({
  text,
  density = "chat",
}: ChatAssistantMarkdownProps): JSX.Element {
  return (
    <div className={`chat-md${density === "panel" ? " chat-md--panel" : ""}`}>
      <ReactMarkdown remarkPlugins={[remarkGfm]}>{text}</ReactMarkdown>
    </div>
  );
}
